import { render } from "./CustomTable.vue?vue&type=template&id=2f9054ef&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=2f9054ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9054ef"]])

export default __exports__